export class SessionStorageModel {
    set privateKey(privateKey) {
        sessionStorage.setItem('privateKey', privateKey);
    }
    get privateKey() {
        return sessionStorage.getItem('privateKey') || '';
    }
}
